import { useState } from "react";
import { uploadsUrl } from "../utils/api";
import "./AmenitiesSection.css";

// 🔹 Limited description with a "More" toggle to reveal the rest
function LimitedDescription({ text, limit = 90 }) {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;
  if (text.length <= limit) return <p>{text}</p>;

  return (
    <p>
      {expanded ? text : text.slice(0, limit) + "…"}
      <button
        type="button"
        className="read-more-btn"
        onClick={() => setExpanded((e) => !e)}
      >
        {expanded ? " Less" : " More"}
      </button>
    </p>
  );
}

// 🔹 Main Component
export default function AmenitiesSection({ projectId, amenities = {} }) {
  const { list = [] } = amenities;

  if (!list.length) return null;

  const doubled = [...list, ...list];

  return (
    <section className="amenities-section section" id="amenities">
      <h2 className="section-heading">World-Class Amenities</h2>

      <div className="amenities-track-wrapper">
        <div className="amenities-track">
          {doubled.map((item, i) => {
            const index = (i % list.length) + 1;

            return (
              <article key={i} className="amenity-card">
                
                {/* ✅ CORRECT IMAGE */}
                <div className="amenity-card__img">
                  <img
                    src={uploadsUrl(projectId, `amenities${index}.webp`)}
                    alt={item.title}
                    loading="lazy"
                    onError={(e) => (e.target.src = "/fallback.webp")}
                  />
                </div>

                <div className="amenity-card__body">
                  <h3>{item.title}</h3>

                  {/* ✅ Title + Description only now (no more "more details"
                      field) — show a short teaser with a "More" button that
                      expands to the full description on click */}
                  <LimitedDescription text={item.description} limit={90} />
                </div>

              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}